import AxiosInstance from "./api";

export const SaInvestmentDetailedRecordService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/sa-investment-detailed-record/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/sa-investment-detailed-record/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/sa-investment-detailed-record", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/sa-investment-detailed-record/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/sa-investment-detailed-record/" + id);
  },
};
